<template>
  <div style="height: 100%; background-color: #f5f6fa">
    <div class="connetTop">
      <div class="CT_left" @click="Back">
        <img src="@/img/back.png" alt=""/>
        <span>返回上一步</span>
      </div>
    </div>
    <div class="common flexBox" v-loading="loading">
      <div class="left">
        <div class="chatTop flexBox">
          <div>聊天记录</div>
        </div>
        <div class="chatMain" ref="chatArea">
          <div
              class="loadMsg"
              v-if="loadFlag && chatData.length == 100 && count > 100"
          >
            {{ loadMsg }}
          </div>
          <div class="recipelBox">
            <div class="recipel_top flexBox" style="margin-bottom: 16px">
              <div
                  style="
                  font-size: 20px;
                  color: rgba(0, 0, 0, 0.85);
                  font-weight: 600;
                "
              >
                病历
              </div>
              <div class="left">
                <span>{{ orderData.patientName }}</span
                ><span>{{ ageSex.sex }}</span
              ><span>{{ ageSex.age }}岁</span>
              </div>
            </div>
            <div class="flexBox" style="justify-content: flex-start">
              <div
                  v-for="(item, index) in diagnosisImg"
                  :key="index"
                  style="margin-right: 10px"
              >
                <el-image
                    style="width: 100px; height: 100px"
                    :src="item"
                    :preview-src-list="[item]"
                >
                </el-image>
              </div>
            </div>
            <div class="diagnosis flexBox">
              <div>患病时长：</div>
              <div>{{ illTime }}</div>
            </div>
            <div class="diagnosis flexBox">
              <div>确诊结果：</div>
              <div>{{ MR_data.illName }}</div>
            </div>
            <div class="diagnosis flexBox">
              <div>疾病史：</div>
              <div>{{ MR_data.diseaseHistory }}</div>
            </div>
            <div class="diagnosis flexBox">
              <div>药物过敏史：</div>
              <div v-if="MR_data.allergyFlag == 0">无</div>
              <div v-else>{{ MR_data.allergyName }}</div>
            </div>
            <div class="diagnosis flexBox">
              <div>肝功能状态：</div>
              <div v-if="MR_data.liverFunction == 'NORMAL'">正常</div>
              <div v-else-if="MR_data.liverFunction == 'ABNORMAL'">异常</div>
              <div v-else-if="MR_data.liverFunction == 'UNKOWN'">未知</div>
            </div>
            <div class="diagnosis flexBox">
              <div>肾功能状态：</div>
              <div v-if="MR_data.liverFunction == 'NORMAL'">正常</div>
              <div v-else-if="MR_data.liverFunction == 'ABNORMAL'">异常</div>
              <div v-else-if="MR_data.liverFunction == 'UNKOWN'">未知</div>
            </div>
            <div class="diagnosis flexBox">
              <div>病情描述：</div>
              <div>{{ MR_data.illDesc }}</div>
            </div>
          </div>
          <div v-for="(item, index) in chatData" :key="index">
            <div
                v-if="
                item.type == 0 ||
                item.type == 3 ||
                (item.type == 8 && item.sendType == 1) ||
                item.type == 5||item.type == 10
              "
            >
              <div
                  class="flexBox doctor"
                  v-if="item.sendType == 2 && item.contentType == 0"
              >
                <div></div>
                <div class="flexBox" style="justify-content: flex-end">
                  <div class="txtBox">{{ item.contentData }}</div>
                  <img src="@/img/doctor.png" alt=""/>
                </div>
              </div>
              <div
                  class="flexBox user"
                  v-else-if="item.sendType == 1 && item.contentType == 0"
              >
                <div class="flexBox" style="justify-content: flex-start">
                  <img src="@/img/患者.png" alt=""/>
                  <div class="txtBox">{{ item.contentData }}</div>
                </div>
                <div></div>
              </div>
              <div
                  class="flexBox doctor"
                  v-else-if="
                  item.sendType == 2 && item.contentType == 1 && item.imgUrl
                "
              >
                <div class="flexBox" style="justify-content: flex-end">
                  <el-image
                      v-if="item.imgUrl"
                      class="imgStyle"
                      :src="item.imgUrl"
                      :preview-src-list="[item.imgUrl]"
                      @error="reLoadImg"
                      lazy
                  >
                  </el-image>
                  <img
                      src="@/img/doctor.png"
                      alt=""
                      style="margin-left: 16px"
                  />
                </div>
                <div></div>
              </div>
              <div
                  class="flexBox user"
                  v-else-if="
                  item.sendType == 1 && item.contentType == 1 && item.imgUrl
                "
              >
                <div class="flexBox" style="justify-content: flex-start">
                  <img
                      src="@/img/患者.png"
                      alt=""
                      style="margin-right: 16px"
                  />
                  <el-image
                      class="imgStyle"
                      :src="item.imgUrl"
                      :preview-src-list="[item.imgUrl]"
                      @error="reLoadImg"
                      lazy
                  >
                    <div
                        slot="error"
                        style="
                        line-height: 180px;
                        color: rgba(0, 0, 0, 0.65);
                        background-color: rgba(0, 0, 0, 0.05);
                        text-align: center;
                        width: 60px;
                        height: 200px;
                      "
                    >
                      加载中
                    </div>
                  </el-image>
                </div>
                <div></div>
              </div>
            </div>
            <div class="recipelBox" v-else-if="item.type == 6">
              <div class="recipel_top flexBox">
                <div class="left">
                  <span>{{ orderData.patientName }}</span
                  ><span>{{ ageSex.sex }}</span
                ><span>{{ ageSex.age }}岁</span>
                </div>
                <div class="right">系统编号：{{ orderData.prescrNo }}</div>
              </div>
              <div class="medicalList">
                <div
                    v-for="(query, index2) in orderData.prescriptionDrugList"
                    :key="index2"
                >
                  <div class="flexBox">
                    <div>
                      <span>{{ query.drugName }}</span
                      >&nbsp;&nbsp;<span>{{ query.specification }}</span>
                    </div>
                    <div>
                      X<span>{{ query.drugNumber }}</span>
                    </div>
                  </div>
                  <div v-if="orderData.prescrKind != 2">
                    用法用量：{{ query.frquName }}，每次{{
                      query.sinDoscnt
                    }}{{ query.sinDosunt }}，{{ query.wayName }}
                  </div>
                </div>
                <!-- 中药处方用法用量 -->
                <div v-if="orderData.prescrKind === 2" class="medicalList">
                  （{{ orderData.num }}付）用法用量：{{ orderData.frquName }}，每次{{
                    orderData.sinDoscnt
                  }}{{ orderData.sinDosunt }}，{{ orderData.wayName }}
                </div>
              </div>
              <div class="diagnosis">
                <span>确诊结果：</span><span>{{ orderData.diagName }}</span>
              </div>
              <div class="tips">
                您的处方已流转至药店，结束问诊后请确认您的订单信息继续购药
              </div>
              <div class="recipel_foote flexBox">
                <div>
                  开方日期：<span>{{ orderData.openTime }}</span>
                </div>
                <div class="RF_button" @click="dialogVisible = true">
                  <span>查看详情</span>
                </div>
              </div>
            </div>
            <div v-else-if="item.type == 2" class="tipsMsg">
              <span> 在您之前还有</span><span>{{ item.contentData }}</span
            ><span>人排队咨询，感谢您的耐心等待…</span>
            </div>
            <div
                v-else-if="item.type == 8 && item.sendType == 2"
                class="flexBox doctor"
            >
              <div></div>
              <div class="flexBox" style="justify-content: flex-end">
                <div style="margin-right: 16px" class="questionBox">
                  <div class="title">&nbsp;</div>
                  <div class="questionContent">
                    {{ item.data.questionText }}
                  </div>
                  <div class="questionOptions">
                    <el-radio-group
                        v-if="item.data.questionType == 'SINGLE_CHOICE'"
                        v-model="item.data.returnAnswer"
                    >
                      <el-radio
                          :label="items.answerCode"
                          v-for="(items, index2) in item.data.answers"
                          :key="index2"
                          class="radioStyle"
                      >{{ items.answerText }}
                      </el-radio>
                    </el-radio-group>
                    <el-checkbox-group v-else v-model="item.data.returnAnswer">
                      <el-checkbox
                          :label="items.answerCode"
                          v-for="(items, index3) in item.data.answers"
                          :key="index3"
                          class="checkBoxStyle"
                      >{{ items.answerText }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  </div>
                <img src="@/img/doctor.png" alt=""/>
                </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
          :visible.sync="refundFlag"
          width="420px"
          class="eventDialog"
          :close-on-click-modal="false"
      >
        <h1 style="text-align: center; margin-bottom: 22px; color: #0caf60">
          退款申请
        </h1>
        <el-form
            :model="refundForm"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            class="demo-ruleForm"
        >
          <el-form-item label="退款原因" prop="reasonCode">
            <el-select
                v-model="refundForm.reasonCode"
                placeholder="请选择退款原因"
                style="width: 100%"
            >
              <el-option label="系统异常" value="1"></el-option>
              <el-option label="挂错号" value="2"></el-option>
              <el-option label="其他" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="退款说明" prop="desc">
            <el-input
                type="textarea"
                v-model="refundForm.desc"
                resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
              @click="refundFlag = false"
              class="closeButton"
              type="success"
              plain
          >取 消</el-button
          >
          <el-button type="primary" class="confirmButton"
          >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
          title="电子处方详情"
          :visible.sync="dialogVisible"
          width="572px"
          class="recipelDetails"
      >
        <table>
          <tr>
            <td>
              <span>处方来源：</span><span>{{ orderData.hospitalName }}</span>
            </td>
            <td>
              <span>开方医师：</span><span>{{ orderData.doctorName }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>系统编号：</span><span>{{ orderData.prescrNo }}</span>
            </td>
            <td>
              <span>开方时间：</span><span>{{ orderData.openTime }}</span>
            </td>
          </tr>
        </table>
        <div class="borderBox"></div>
        <table class="userBox">
          <tr>
            <td>
              <span>姓名：</span><span>{{ MR_data.userName }}</span>
            </td>
            <td>
              <span>性别：</span><span>{{ ageSex.sex }}</span>
            </td>
            <td>
              <span>年龄：</span><span>{{ ageSex.age }}岁</span>
            </td>
          </tr>
        </table>
        <div class="diagnosisBox diagnosisBox1">
          <p><span class="title_icon">&nbsp;</span>诊断结果</p>
          <p>{{ orderData.diagName }}</p>
        </div>
        <div class="diagnosisBox">
          <p><span class="title_icon">&nbsp;</span>疾病史</p>
          <p>
            <span>{{ MR_data.diseaseHistory }}</span>
          </p>
        </div>
        <div class="diagnosisBox">
          <p><span class="title_icon">&nbsp;</span>药物过敏史</p>
          <p>
              <span v-if="MR_data.allergyFlag != 0">{{ MR_data.allergyName }}</span
              ><span v-else>无</span>
          </p>
        </div>
        <div class="diagnosisBox">
          <p><span class="title_icon">&nbsp;</span>肝功能状态</p>
          <p>
            <span v-if="MR_data.liverFunction == 'NORMAL'">正常</span>
            <span v-else-if="MR_data.liverFunction == 'ABNORMAL'">异常</span>
            <span v-else-if="MR_data.liverFunction == 'UNKOWN'">未知</span>
          </p>
        </div>
        <div class="diagnosisBox">
          <p><span class="title_icon">&nbsp;</span>肾功能状态</p>
          <p>
            <span v-if="MR_data.renalFunction == 'NORMAL'">正常</span>
            <span v-else-if="MR_data.renalFunction == 'ABNORMAL'">异常</span>
            <span v-else-if="MR_data.renalFunction == 'UNKOWN'">未知</span>
          </p>
        </div>
        <div class="medicalList">
          <p style="margin-bottom: 10px">
            <span class="title_icon">&nbsp;</span>RP
          </p>
          <div
              v-for="(item, index) in orderData.prescriptionDrugList"
              :key="index"
          >
            <div class="flexBox">
              <div>
                <span>{{ item.drugName }}</span
                ><span v-if="orderData.prescrKind != 2">{{ item.specification }}</span>
              </div>
              <div>
                X<span>{{ item.drugNumber }}</span>
              </div>
            </div>
            <!-- 西药处方：每个药品显示用法用量 -->
            <div v-if="orderData.prescrKind != 2">
              用法用量：{{ item.frquName }}，每次{{
                item.sinDoscnt
              }}{{ item.sinDosunt }}，{{ item.wayName }}
            </div>
          </div>
          <!-- 中药处方：只显示一个统一的用法用量 -->
          <div v-if="orderData.prescrKind == 2" style="margin-top: 10px; padding: 8px; background-color: #f9f9f9; border-radius: 4px;">
            <div>
              （{{ orderData.num }}付）用法用量：{{ orderData.frquName }}，每次{{
                orderData.sinDoscnt
              }}{{ orderData.sinDosunt }}，{{ orderData.wayName }}
            </div>
          </div>
        </div>
        <div class="borderBox"></div>
        <div class="tips">
          <span>!</span
          ><span>本处方仅限{{ orderData.pharmacyName }}使用！</span>
        </div>
        <div class="foote">
          <p>备注：</p>
          <p>处方仅在您所处的开放药店3日有效</p>
          <p>为保障您的权益，按照监管部门要求，电子处方的部分信息已加密脱敏</p>
        </div>
      </el-dialog>
      <el-dialog
          :visible.sync="outFlag"
          width="30%"
          :show-close="false"
          :close-on-click-modal="false"
          class="tipsMsgBox"
      >
        <span style="font-size: 20px; font-weight: 800">
          {{ Msg }}
        </span>
        <div class="backButton" @click="back">
          <span>离开</span>
        </div>
      </el-dialog>
      <el-dialog
          :visible.sync="outFlag2"
          width="30%"
          :show-close="false"
          :close-on-click-modal="false"
          class="tipsMsgBox"
          :modal="false"
      >
        <span style="font-size: 20px; font-weight: 800">
          {{ errorMsg }}
        </span>
      </el-dialog>
      <el-dialog :visible.sync="endFlag" width="420px" class="eventDialog">
        <table>
          <tr>
            <td><span class="icon">!</span></td>
            <td class="headTxt">是否确认要退出问诊？</td>
          </tr>
        </table>
        <span slot="footer" class="dialog-footer">
          <el-button
              @click="endFlag = false"
              class="closeButton"
              type="success"
              plain
          >取 消</el-button
          >
          <el-button
              type="success"
              @click="goHome"
              class="confirmButton"
              v-loading="loading"
          >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import store from "@/store/store";
import {imgDownLoad, msgList,} from "@/api/index";
import {getsocketUrl} from "@/utils/index";
import TopHeader from "@/components/layout/Header.vue";
import Camera from "@/components/tool/Camera.vue";

export default {
  components: {
    Camera,
    TopHeader,
  },
  data() {
    return {
      dialogVisible: false,
      MR_data: JSON.parse(localStorage.getItem("MR_data")),
      ageSex: JSON.parse(localStorage.getItem("ageSex")),
      illTime: "",
      socketUrl2: getsocketUrl(),
      chatData: [],
      msg: "",
      orderData: {},
      createTime: "",
      outFlag: false,
      second: 30,
      cp: 1,
      historyFlag: false,
      loadMsg: "上拉加载历史记录",
      count: 1,
      countFlag: 0,
      mountedFlag: true,
      scrollHeight: 0,
      loadFlag: true,
      loading: true,
      loading2: false,
      loading3: false,
      outFlag2: false,
      errorMsg: "",
      refundFlag: false,
      refundButtonFlag: true,
      Msg: "",
      refundForm: {
        orderNumber: "",
        reasonCode: "",
        desc: "",
      },
      rules: {
        reasonCode: [
          {required: true, message: "请选择退款原因", trigger: "change"},
        ],
      },
      clickFlag: true,
      countDownBack: "",
      firstLoad: true,
      endFlag: false,
      socket_init: null,
      socketFlag: false,
      lockReconnect: true,
      heartCheck: null,
      reconnectFlag: false,
      reconnectCount: 0,
      initFLag: false,
      initCount: 0,
      storeImgData: {},
      sendFlag: true,
      diagnosisImg: [],
    };
  },
  created() {
  },
  mounted() {
    let that = this;

    this.msgLists();
    this.loadData();
    this.$nextTick(() => {
      this.scrollToBottom();
    });
    const scrollview = this.$refs["chatArea"];
    scrollview.addEventListener("scroll", this.scrollChange, true);
    that.MR_data = JSON.parse(localStorage.getItem("MR_data"));
  },
  updated() {
    // 在接收到新消息的时候触发方法将滚动条定位到底部
    if (this.historyFlag == false) {
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    }
  },
  beforeDestroy() {
    let that = this;
    if (!that.lockReconnect) {
      that.socket_init.close();
      that.lockReconnect = true;
      that.reconnectFlag = true;
      clearInterval(that.heartCheck);
    }
  },
  computed: {
    ImgData() {
      let ImgData = {
        getImg: store.state.getImg,
        cover: store.state.cover,
      };
      this.storeImgData = ImgData;
      return ImgData;
    },
  },
  methods: {
    async msgLists() {
      let that = this;
      let postData = {
        cp: this.cp,
        lz: 100,
        orderNumber: this.MR_data.orderNumber,
      };
      var finishFlag = false;
      var List = [];
      await msgList(postData).then((data) => {
        if (data.code == 0) {
          data.data.data.forEach((res) => {
            if (res.type == 3) {
              this.refundButtonFlag = false;
              let doctorData = JSON.parse(res.contentData);
              //   this.MR_data.doctorCode = doctorData.doctorCode;
              //   this.MR_data.doctorLevel = doctorData.doctorLevel;
              //   this.MR_data.doctorName = doctorData.doctorName;
              res.contentData = doctorData.message;
            }
            if (res.type == 7) {
              this.refundButtonFlag = false;
            }
          });
          if (data.data.data.length > 0) {
            List = data.data.data.reverse();
          }
          this.loading = false;
        } else {
          this.loading = false;
          this.outFlag2 = true;
          this.errorMsg = data.msg;
          setTimeout(() => {
            this.outFlag2 = false;
          }, 2000);
        }
        
        List.forEach(async (item) => {
          if (item.type == 6 || item.type == "6") {
            this.orderData = JSON.parse(item.contentData);
            this.createTime = item.createTime;
          }
          if (item.type == 3) {
            this.refundButtonFlag = false;
          }
          //   if (item.type == 5) {
          //     finishFlag = true;
          //     if (finishFlag) {
          //       this.outFlag = true;
          //       this.Msg = "问诊结束，将在" + this.second + "秒后离开问诊页面";
          //       this.countDownBack = setInterval(() => {
          //         this.second--;
          //         this.Msg = "问诊结束，将在" + this.second + "秒后离开问诊页面";
          //         if (this.second == 0) {
          //           this.outFlag = false;
          //           this.reconnectFlag = true;
          //           this.$router.push("/Home");
          //           clearInterval(this.countDownBack);
          //         }
          //       }, 1000);
          //     }
          //   }
          if (item.type == 8) {
            if (item.sendType == 2) {
              item.data = {
                questionText: item.contentData,
                historyFlag: true,
              };
            }
          }
          if (item.contentType == 1) {
            if (item.contentData.indexOf("http") != -1) {
              item.imgUrl = item.contentData
            } else {
              let imgPostData = {
                path: item.contentData,
              };
              await imgDownLoad(imgPostData).then((res) => {
                if (res.code == 0) {
                  item.imgUrl = "data:image/jpeg;base64," + res.data;
                  this.chatData = List;
                }
              });
            }
          }
          this.chatData = List;
          this.count = data.data.count;
          this.countFlag = Math.ceil(this.count / 10) - 1;
          this.$forceUpdate();
        });
      });
    },
    loadData() {
      switch (this.MR_data.illTime) {
        case 1:
          this.illTime = "一个月内";
          break;
        case 2:
          this.illTime = "半年内";
          break;
        case 3:
          this.illTime = "一年内";
          break;
        case 4:
          this.illTime = "一年以上";
          break;
      }
      if (this.MR_data.diagnosisImg) {
        var imgArr = this.MR_data.diagnosisImg.split("|");
        for (let a = 0; a < imgArr.length; a++) {
          let postData = {
            path: imgArr[a],
          };
          imgDownLoad(postData).then((res) => {
            if (res.code == 0) {
              this.diagnosisImg.push("data:image/jpeg;base64," + res.data);
            }
          });
        }
      }
    },
    refundDialog() {
      this.refundFlag = true;
      this.refundForm = {};
      if (!this.firstLoad) {
        this.$refs["ruleForm"].resetFields();
        this.firstLoad = false;
      }
    },
    reLoadImg() {
      this.$forceUpdate();
    },
    //滚动固定
    scrollToBottom() {
      this.$nextTick(() => {
        let chat = this.$el.querySelector(".chatMain");

        if (this.mountedFlag == true) {
          this.scrollHeight = chat.scrollHeight;
          this.mountedFlag = false;
        }
        chat.scrollTop = chat.scrollHeight;
      });
    },
    async scrollChange() {
      let chat = this.$el.querySelector(".chatMain");
      this.scrollHeight = chat.scrollHeight;
      var List = [];
      if (chat.scrollTop == 0 && this.cp <= this.countFlag) {
        this.cp = this.cp - 0 + 1;
        let postData = {
          cp: this.cp,
          lz: 100,
          orderNumber: this.MR_data.orderNumber,
        };
        this.loadMsg = "历史记录加载中。。。。";
        this.historyFlag = true;
        await msgList(postData).then(async (data) => {
          if (data.code == 0) {
            if (data.data.data.length > 0) {
              List = data.data.data;
              this.chatData.forEach((item) => {
                if (item.type == "6") {
                  this.orderData = JSON.parse(item.contentData);
                  this.createTime = item.createTime;
                }
              });
            }
            this.loading = false;
          } else {
            this.outFlag2 = true;
            this.errorMsg = data.msg;
            setTimeout(() => {
              this.outFlag2 = false;
            }, 2000);
          }
          this.loadMsg = "上拉加载历史记录";
        });
        List.forEach(async (item) => {
          if (item.type == "6") {
            this.orderData = JSON.parse(item.contentData);
            this.createTime = item.createTime;
          }
          if (item.type == 3) {
            this.refundButtonFlag = false;
          }
          if (item.type == 5) {
            finishFlag = true;
          }
          if (item.contentType == 1) {
            if (item.contentData.indexOf("http") != -1) {
              item.imgUrl = item.contentData;
            } else {
              let imgPostData = {
                path: item.contentData,
              };
              await imgDownLoad(imgPostData).then((res) => {
                if (res.code == 0) {
                  item.imgUrl = "data:image/jpeg;base64," + res.data;
                }
              });
            }
            this.countFlag = Math.ceil(this.count / 10) - 1;
            this.$forceUpdate();
          }
        });
        await List.forEach((query2) => {
          this.chatData.unshift(query2);
        });
        await (chat.scrollTop = chat.scrollHeight - this.scrollHeight)
      } else if (this.cp > this.countFlag) {
        this.loadFlag = false;
      }
    },
    back() {
      this.outFlag = false;
      clearInterval(this.countDownBack);
      this.$router.push("/Home");
    },
    Back() {
      this.$router.go(-1);
    },
    goHome() {
      this.endFlag = false;
      clearInterval(this.countDownBack);
      this.$router.push("/Home");
    },
  },
};
</script>
<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

ul, li {
  list-style: none;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 16px;
  height: 16px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #0caf60;
}

/* Element UI 组件样式覆盖 */
/deep/ .el-input__inner:focus,
/deep/ .el-input.is-active .el-input__inner,
/deep/ .el-select .el-input.is-focus .el-input__inner,
/deep/ .el-select .el-input__inner:focus {
  border-color: #0caf60;
  outline: 0;
}

/deep/ .el-textarea__inner:focus {
  border-color: #0caf60;
  outline: 0;
}

/deep/ .el-select-dropdown__item.selected {
  color: #0caf60;
}

/deep/ .el-button--success {
  background: #0caf60;
  border: 0px;
  border-radius: 8px;
}

/deep/ .el-button--success.is-plain {
  color: #0caf60;
  background-color: #fff;
  border: 1px solid #86d6af;
  border-radius: 8px;
}

/deep/ .el-button--success.is-plain:active {
  color: #fff;
  background: #0caf60;
  border: 1px solid #0caf60;
}

/deep/ .el-button--success.is-plain:hover {
  color: #fff;
  background: #0caf60;
  border: 1px solid #0caf60;
}

/deep/ .el-button--success:active {
  color: #fff;
  background: #86d6af;
  border: 0px;
}

/deep/ .el-button--success:hover {
  color: #fff;
  background: #86d6af;
  border: 0px;
}

/deep/ .el-button--success:focus {
  background: #0caf60;
  border-color: #0caf60;
}

/deep/ .el-button--success.is-plain:focus {
  background: #0caf60;
  border-color: #0caf60;
}

/deep/ .el-button--success.is-disabled,
/deep/ .el-button--success.is-disabled:active,
/deep/ .el-button--success.is-disabled:focus,
/deep/ .el-button--success.is-disabled:hover {
  color: #fff;
  background-color: #86d6af;
  border-color: #86d6af;
}

/deep/ .el-button--text {
  color: #0caf60;
}

/deep/ .el-button--text:active {
  color: #86d6af;
}

/deep/ .el-button--text:hover {
  color: #86d6af;
}

/deep/ .el-button--text:focus,
/deep/ .el-button--text:hover {
  color: #0caf60;
}

/deep/ .el-dialog {
  border-radius: 12px;
}

/deep/ .el-dialog__headerbtn:focus .el-dialog__close,
/deep/ .el-dialog__headerbtn:hover .el-dialog__close {
  color: #0caf60;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: rgba(0, 0, 0, 0.65);
}

/deep/ .el-select .el-input__inner:focus {
  border-color: #0caf60 !important;
}

/deep/ .el-input.is-active .el-input__inner,
/deep/ .el-input__inner:focus {
  border-color: #0caf60;
  outline: 0;
}

/deep/ .el-cascader .el-input .el-input__inner:focus,
/deep/ .el-cascader .el-input.is-focus .el-input__inner {
  border-color: #0caf60;
}

/deep/ .el-cascader-node.in-active-path,
/deep/ .el-cascader-node.is-active,
/deep/ .el-cascader-node.is-selectable.in-checked-path {
  color: #0caf60;
}

/deep/ .el-time-panel__btn.confirm {
  color: #0caf60;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0caf60;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0caf60;
  border-color: #0caf60;
}

/deep/ .el-checkbox__inner:hover {
  border-color: #0caf60;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #0caf60;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #0caf60;
  background: #fff;
}

/deep/ .el-radio__inner:hover {
  border-color: #0caf60;
}

/deep/ .el-radio__input.is-checked .el-radio__inner:after {
  background-color: #0caf60;
  transform: translate(-50%, -50%) scale(-1);
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #0caf60;
}

/deep/ .el-range-editor.is-active,
/deep/ .el-range-editor.is-active:hover,
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #0caf60;
}

/deep/ .el-date-table td.today span {
  color: #0caf60;
}

/deep/ .el-date-table td.available:hover {
  color: #0caf60;
}

/deep/ .el-date-table td.end-date span,
/deep/ .el-date-table td.start-date span {
  border-color: #0caf60;
  background-color: #0caf60;
}

/deep/ .el-date-table td.in-range div,
/deep/ .el-date-table td.in-range div:hover,
/deep/ .el-date-table.is-week-mode .el-date-table__row.current div,
/deep/ .el-date-table.is-week-mode .el-date-table__row:hover div {
  background: #00ff8317;
}

/deep/ .el-picker-panel__link-btn.is-plain:focus,
/deep/ .el-picker-panel__link-btn.is-plain:hover,
/deep/ .el-picker-panel__link-btn.is-plain:active {
  color: #0caf60;
  border-color: #0caf60;
}

/deep/ .el-picker-panel__icon-btn:hover {
  color: #0caf60;
}

/deep/ .el-collapse-item__header.focusing:focus:not(:hover) {
  color: #0caf60;
}

/deep/ .el-date-table td.current:not(.disabled) span {
  background-color: #0caf60;
}

/deep/ .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #0caf60;
}

/deep/ .el-submenu__title:hover {
  background: #9fffd052 !important;
}

/deep/ .el-tooltip__popper.is-dark {
  max-width: 50%;
}

/* 分页样式 */
/deep/ .el-pagination button:hover {
  color: #86d6af;
}

/deep/ .el-pager li.active {
  color: #0caf60;
}

/deep/ .el-pager li:hover {
  color: #0caf60;
}

/* 弹窗样式 */
/deep/ .tipsMsgBox .el-dialog__header {
  display: none;
}

/deep/ .tipsMsgBox .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

/* 上传组件样式 */
/deep/ .none-up .el-upload--picture-card {
  display: none;
}

.common {
  padding: 24px 32px;
  padding-top: 0px;
  /* min-height: 100%; */
  box-sizing: border-box;
  background: #f5f6fa;
  justify-content: space-between;
}

.flexBox {
  display: flex;
  align-items: stretch !important;
}

.common > .left {
  margin-right: 24px;
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
}

.left .chatTop {
  border: 1px solid #eeeff2;
  padding: 20px 24px;
  font-weight: 600;
  font-size: 20px;
}

.left .chatTop > div > img {
  margin-right: 12px;
  height: 48px;
  width: 48px;
}

.left .chatTop .flexBox {
  width: 100%;
  justify-content: space-between;
}

.left .chatTop .docName {
  margin-right: 8px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.left .chatTop .docType {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.left .chatTop .videoBox {
  margin-top: 8px;
  box-sizing: border-box;
  padding: 8px 16px;
  border-radius: 15px;
  /* border: 1px solid #0caf60; */
  color: #fff;
  background: #0caf60;
  font-size: 14px;
  width: 124px;
  height: 36px;
  cursor: pointer;
}

.left .chatTop .videoBox img {
  margin-right: 8px;
  margin-top: -2px;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}

.left .chatTop .videoBox:hover {
  background: #86d6af;
}

.left .chatMain {
  box-sizing: border-box;
  padding-bottom: 10px;
  height: 42rem;
  overflow-y: auto;
}

.chatMain > div > div > .flexBox {
  /* width: 50%; */
  padding: 6px 24px;
}

.chatMain .doctor,
.chatMain .user {
  justify-content: space-between;
}

.chatMain .doctor .flexBox > img,
.chatMain .user .flexBox > img {
  width: 48px;
  height: 48px;
  vertical-align: middle;
}

.chatMain .doctor .flexBox > .txtBox,
.chatMain .user .flexBox > .txtBox {
  margin: 0 16px;
  padding: 12px 16px 0px ;
}

.doctor .flexBox > .txtBox {
  color: #fff;
  font-size: 14px;
  background: #0caf60;
  border-radius: 12px 0px 12px 12px;;
  line-height: 22px;
}

.user .flexBox > .txtBox {
  background: #f9fafb;
  border-radius: 12px 0px 12px 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.chatMain .recipelBox {
  margin-top: 12px;
  margin-left: 24px;
  margin-bottom: 10px;
  padding: 10px 16px;
  width: 484px;
  box-sizing: border-box;
  border: 1px solid #eeeff2;
  border-radius: 12px;
  background: #ffffff;
}

.recipel_top {
  padding-bottom: 9px;
  border-bottom: 1px solid #eeeff2;
  justify-content: space-between;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.recipel_top .left span {
  margin-right: 10px;
}

.recipel_top .left span:nth-child(1) {
  margin-right: 22px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
}

.medicalList {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}

.medicalList .flexBox {
  margin-bottom: 2px;
  justify-content: space-between;
}

.medicalList .flexBox > div:nth-child(1) {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.diagnosis {
  margin-bottom: 16px;
}

.diagnosis.flexBox {
  justify-content: flex-start;
  flex-shrink: 0;
}

.diagnosis div:nth-child(1) {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  flex-shrink: 0;
}

.diagnosis div:nth-child(2) {
  color: rgba(0, 0, 0, 0.85);
  word-break: break-all;
  font-weight: 600;
}

.recipelBox .tips {
  margin-bottom: 16px;
  padding: 7px 8px;
  border-radius: 4px;
  background: rgba(255, 120, 32, 0.08);
  color: #ff7820;
  font-size: 12px;
}

.recipel_foote {
  justify-content: space-between;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.recipel_foote .RF_button {
  border-radius: 8px;
  border: 1px solid #0caf60;
  color: #0caf60;
  cursor: pointer;
}

.RF_button span {
  display: inline-block;
  padding: 8px 24px;
}

.RF_button:active {
  background: #0caf60;
  color: #fff;
}

.recipelDetails /deep/ .el-dialog {
  border-radius: 12px;
}

.recipelDetails /deep/ .el-dialog__body {
  padding-top: 16px;
  padding-bottom: 24px;
}

.recipelDetails table {
  width: 100%;
}

.recipelDetails table tr {
  line-height: 28px;
}

.recipelDetails table td span {
  font-size: 14px;
}

.recipelDetails table td span:nth-child(1) {
  color: rgba(0, 0, 0, 0.65);
}

.recipelDetails table td span:nth-child(2) {
  color: rgba(0, 0, 0, 0.85);
}

.borderBox {
  margin: 10px 0px;
  border-top: 1px solid #eeeff2;
  border-bottom: 1px solid #eeeff2;
  height: 10px;
}

.userBox {
  margin-bottom: 10px;
}

.userBox td span:nth-child(2) {
  font-size: 16px;
}

.diagnosisBox p:nth-child(1) {
  margin-bottom: 10px;
}

.diagnosisBox p:nth-child(2) {
  margin-bottom: 10px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
}

.recipelDetails .tips {
  margin-bottom: 10px;
  color: #faad14;
}

.recipelDetails .tips span:nth-child(1) {
  margin-right: 4px;
  padding: 0px 7px;
  color: #fff;
  background: #faad14;
  border-radius: 50%;
  display: inline-block;
}

.recipelDetails .foote {
  color: rgba(0, 0, 0, 0.65);
  line-height: 24px;
}

.txtArea /deep/ .el-textarea__inner {
  padding: 20px;
  border: 1px solid #f1f2f4;
  border-radius: 12px 12px 0px 0px;
  /* background: #f1f2f4; */
  /* color: #a0aec0; */
  font-size: 14px;
  resize: none;
}

.txtArea /deep/ .el-textarea__inner:focus {
  border: 1px solid #f1f2f4;
}

.right_top,
.right_bottom {
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px;
  padding: 0px 24px;
}

.bottomButton {
  margin-top: 8px;
  margin-bottom: 8px;
  padding-left: 24px;
  font-size: 14px;
  color: #a0aec0;
  background: #fff;
}

.bottomButton img {
  margin-right: 8px;
  vertical-align: middle;
}

.bottomButton > div {
  border: 1px solid #eeeff2;
  background: #0caf60;
  color: #fff;
  border-radius: 15px;
  padding: 6px 16px;
  cursor: pointer;
}

.bottomButton > div:active {
  border-color: #0caf60;
}

.bottomButton > div:nth-child(1) {
  margin-right: 8px;
}

.sendMsgBox {
  padding: 0px 16px;
}

.useArea {
  padding: 8px 20px;
  justify-content: space-between;
  background: #fafafa;
  border-radius: 0px 0px 12px 12px;
}

.useArea img:nth-child(1) {
  margin-right: 12px;
}

.useArea img {
  vertical-align: middle;
}

.useArea .sendButton {
  background: #0caf60;
  border-radius: 8px;
  padding: 10px 16px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.useArea .sendButton:hover {
  background: #86d6af;
}

.useArea .sendButton img {
  margin-right: 12px;
  vertical-align: middle;
}

.right_top {
  margin-top: 24px;
  margin-bottom: 24px;
  width: 440px;
  height: 210px;
  text-align: center;
}

.right_top > div:nth-child(1) > img {
  margin-top: -32px;
  margin-bottom: 8px;
}

.right_top > :nth-child(2) {
  margin-bottom: 4px;
  font-size: 18px;
}

.right_top > :nth-child(3),
.right_top > :nth-child(4) {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.right_top > :nth-child(5) {
  margin-top: 14px;
}

.right_top > :nth-child(5) > span:nth-child(1) {
  margin-right: 16px;
  display: inline-block;
  padding: 2px 8px;
  border: 1px solid #0caf60;
  color: #0caf60;
  border-radius: 4px;
}

.right_top > :nth-child(5) > img {
  margin-right: 2px;
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

.right_top > :nth-child(5) > span:nth-child(3) {
  font-size: 14px;
}

.right_bottom {
  padding: 20px 24px;
  width: 440px;
  box-sizing: border-box;
}

.right_bottom > div:nth-child(1) {
  margin-bottom: 18px;
  text-align: center;
}

.right_bottom > div:nth-child(1) img {
  width: 64px;
  height: 64px;
}

.right_bottom > div:nth-child(2) {
  text-align: center;
  margin-bottom: 24px;
}

.right_bottom > div:nth-child(2) > span:nth-child(1) {
  margin-right: 14px;
  font-size: 18px;
  font-weight: 600;
}

.right_bottom > div:nth-child(2) > span:nth-child(2),
.right_bottom > div:nth-child(2) > span:nth-child(3),
.right_bottom > div:nth-child(2) > span:nth-child(4) {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.right_bottom > div:nth-child(2) > span:nth-child(2) {
  margin-right: 12px;
}

.title_icon {
  margin-right: 8px;
  width: 4px;
  height: 20px;
  background: #0caf60;
  border-radius: 3px;
}

.title {
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.right_bottom > div:nth-child(3) {
  margin-bottom: 24px;
}

.right_bottom > div:nth-child(4) {
  margin-bottom: 8px;
}

.right_bottom > div:nth-child(5) {
  margin-bottom: 24px;
  padding: 17px 16px;
  box-sizing: border-box;
  min-width: 392px;
  height: 122px;
  border-radius: 8px;
  color: rgba(0, 0, 0, 0.65);
  background: #f9fafb;
  font-size: 14px;
}

.right_bottom > div:nth-child(6) {
  margin-bottom: 24px;
}

.right_bottom > div:nth-child(7) {
  margin-bottom: 24px;
}

/* .right_bottom > div:nth-child(7) span {
  color: rgba(0, 0, 0, 0.65);
} */
.warningIcon {
  box-sizing: border-box;
  color: #fff;
  background: #faad14;
  border-radius: 50%;
  padding: 0px 8px;
  margin-right: 8px;
}

/* .right_bottom > div:nth-child(8) span {
  color: rgba(0, 0, 0, 0.65);
} */
.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.backButton {
  margin-top: 40px;
}

.backButton span {
  padding: 6px 24px;
  color: #fff;
  font-size: 16px;
  line-height: 20px;
  background: #0caf60;
  border-radius: 8px;
  cursor: pointer;
}

.backButton span:active {
  background: #86d6af;
}

.loadMsg {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a0aec0;
  text-align: center;
}

.tipsMsg {
  /* display: inline-block; */
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a0aec0;
  line-height: 19px;
  text-align: center;
}

.tipsMsg :nth-child(2) {
  color: #ff7820;
}

.eventDialog /deep/ .el-dialog__body {
  padding-top: 0px;
}

.eventDialog .icon {
  margin-right: 16px;
  padding: 0px 8px;
  border-radius: 50%;
  background: #faad14;
  color: #fff;
}

.eventDialog /deep/ .el-dialog__close {
  color: #a0aec0;
}

.eventDialog /deep/ .el-button {
  border-radius: 8px;
}

.eventDialog /deep/ .el-dialog {
  border-radius: 12px;
}

.eventDialog /deep/ .el-dialog__header {
  background: none;
}

.eventDialog .headTxt {
  line-height: 48px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 18px;
}

.eventDialog .tips {
  padding: 0px;
  color: rgba(0, 0, 0, 0.65);
}

.eventDialog .confirmButton {
  border: 0px;

  background: #0caf60;
}

.eventDialog /deep/ .el-button--primary:active {
  border: 0px;
  background: #86d6af;
}

.eventDialog .closeButton {
  border: 1px solid #eeeff2;
}

.bottomButton .arrest {
  pointer-events: none;
}

.iconButton {
  margin-right: 10px;
  line-height: 41px;
  font-size: 30px;
  cursor: pointer;
  color: #0caf60;
}

.iconButton:hover {
  color: #0caf60;
}

.chatMain .user .flexBox .imgStyle {
  height: auto;
  width: auto;
  max-width: 200px;
  max-height: 200px;
}

.questionBox {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

.questionBox > .title {
  padding: 6px 10px;
  background-color: #0caf60;
  color: #fff;
  font-size: 20px;
  border-radius: 8px 8px 0px 0px;
}

.questionBox .questionContent {
  margin: 10px 0px;
  padding: 0px 10px;
  width: 326px;
}

.questionBox .questionOptions {
  padding: 0px 10px;
  margin-bottom: 10px;
}

.questionBox .questionBottom {
  margin-bottom: 20px;
  padding: 0px 20px;
}

.connetTop {
  padding: 24px 32px;
  /* width: 100%; */
  display: flex;
  overflow: auto;
  justify-content: space-between;
}

.CT_left {
  box-sizing: border-box;
  padding: 11px 0px;
  padding-left: 16px;
  width: 140px;
  /* height: 44px; */
  background: #ffffff;
  border-radius: 8px;
  /* padding: 0px 0px; */
  cursor: pointer;
}

.CT_left:active {
  color: #0caf60;
}

.CT_left img,
.CT_right img {
  margin-right: 4px;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

@media only screen and (max-height: 617px) {
  .left .chatMain {
    height: 24rem;
  }
}
</style>